import { useSatuEventTracker } from 'utils/satuEvent'
import AndroidHandler from 'utils/androidHandler'
import { useAuth } from 'utils/auth'
import { APP_DEVICE_ID_STORAGE_KEY } from 'configs/android'
import { useLocalStorage } from 'utils/hooks/useLocalStorage'

import type { TSETrackEventDefaultAtributes } from 'types/pendaftaran-ikm'

const SATU_EVENT_NAME = 'guru_core_pwa_event_tracker_v1'
const TRACKER_EVENT_NAME = 'GURU_CORE_APP'
const DEFAULT_TIMEOUT = 5000 // 5 seconds

export const useSETrackEvent = () => {
  const [, , , getAppDeviceIdValue] = useLocalStorage(
    APP_DEVICE_ID_STORAGE_KEY,
    null
  )

  const appDeviceID = getAppDeviceIdValue()
  const hasAppDeviceID = Boolean(appDeviceID)
  const androidHandler = AndroidHandler()
  const { session } = useAuth()
  const { SETrackEvent, SETransformAttrs } = useSatuEventTracker()

  const SETrackEventDefaultAtributes: Omit<
    TSETrackEventDefaultAtributes,
    'screen_name'
  > = {
    is_login: [Boolean(session), 'bool'],
    is_webview: [androidHandler.enabled, 'bool'],
    email: session?.user?.email ?? null,
  }

  const SETrackComponent = (
    activity_type: string,
    additionalAttributes?: Record<string, any>
  ): void => {
    SETrackEvent({
      eventName: SATU_EVENT_NAME,
      eventParams: {
        activity_type,
        event_name: TRACKER_EVENT_NAME,
        user_id: session?.user?.id,
        ...(hasAppDeviceID ? { device_id: appDeviceID } : {}),
        attributes: SETransformAttrs({
          ...SETrackEventDefaultAtributes,
          ...additionalAttributes,
        }),
      },
      timeout: DEFAULT_TIMEOUT,
      keepAlive: true,
    })
  }

  const SETrackDocumentLandingPage = (
    activityType: string,
    attributes: Record<string, any>
  ): void => {
    SETrackComponent(activityType, attributes)
  }

  const SETrackDocumentError = (
    activityType: string,
    attributes: Record<string, any>
  ): void => {
    const source = (lv: number) => {
      if (lv === 1) return 'KUMPULAN_DOKUMEN_CATEGORY_PAGE'
      else if (lv > 1) return 'KUMPULAN_DOKUMEN_SUBCATEGORY_PAGE'
    }

    SETrackComponent(activityType, {
      ...attributes,
      source:
        typeof attributes.source === 'number'
          ? source(attributes.source)
          : attributes.source,
    })
  }

  return {
    SETrackDocumentLandingPage,
    SETrackDocumentError,
  }
}
